// Token consumption for the React implementation.
//
// The ONLY source of visual values is @roi-pros/px-tokens, exposed as CSS custom properties
// (`--lu-<group>-<key>`). Components reference them via `token(group, key)`; no raw colors,
// spacing, typography, radii, or other visual constants appear anywhere in px-react.
// The token VALUES live in px-tokens' generated CSS (consumers include it); px-react only
// references the variable names, so runtime theming works.
const kebab = (s) => s.replace(/[A-Z]/g, (m) => '-' + m.toLowerCase());
/** Returns a CSS reference to a px-tokens custom property, e.g. token('color','primary') -> 'var(--lu-color-primary)'. */
export function token(group, key) {
    return `var(--lu-${group}-${kebab(key)})`;
}
/** Convenience accessors (still 100% sourced from px-tokens CSS variables). */
export const color = (key) => token('color', key);
export const space = (key) => token('spacing', key);
export const fontSize = (key) => token('font', key);
export const radius = (key) => token('radius', key);
export const borderWidth = (key) => token('border', key);
/** A token-driven border shorthand: line() -> hairline border in the border color. */
export const line = (c = color('border'), width = 'hairline') => `${borderWidth(width)} solid ${c}`;
/** Visible keyboard-focus ring (Accessibility Baseline: a11y.visible-focus) — token-sourced. */
export const focusRingStyle = {
    outline: line(color('focus'), 'thick'),
    outlineOffset: space('xs'),
};
//# sourceMappingURL=tokens.js.map